import { SxProps } from '@mui/material';

export const CardSx = (hasBorder: boolean): SxProps => ({
  width: '100%',
  padding: 3,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  gap: 1,
  borderRadius: 1,
  border: hasBorder ? '1px solid rgba(19, 20, 20, 0.12)' : 'none',
  boxShadow: 'none',
  minHeight: '300px'
});

export const ImageSx: SxProps = {
  maxWidth: '135px',
  width: '100%',
  marginBottom: 2
};

export const TitleSx: SxProps = {
  fontFamily: 'PP Pangram Sans, sans-serif',
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: 1.14,
  marginBottom: 0.5
};

export const DescriptionSx: SxProps = {
  fontFamily: 'Inter, sans-serif',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: 1.43,
  color: '#131414',
  maxWidth: '450px'
}; 
